/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRescueRequest
 */
export interface UpdateRescueRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRescueRequest
     */
    newFirmwareId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRescueRequest
     */
    currentFirmwareId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRescueRequest
     */
    deviceTypeId: string;
}

export function UpdateRescueRequestFromJSON(json: any): UpdateRescueRequest {
    return UpdateRescueRequestFromJSONTyped(json, false);
}

export function UpdateRescueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRescueRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newFirmwareId': json['newFirmwareId'],
        'currentFirmwareId': json['currentFirmwareId'],
        'deviceTypeId': json['deviceTypeId'],
    };
}

export function UpdateRescueRequestToJSON(value?: UpdateRescueRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'newFirmwareId': value.newFirmwareId,
        'currentFirmwareId': value.currentFirmwareId,
        'deviceTypeId': value.deviceTypeId,
    };
}

